import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";



const purchaseSave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "purchase/action", data, headerConfig);
        return response;
};

const purchaseList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "purchase/list", data, headerConfig);
        return response;
};

const purchaseGetByID = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "purchase/get-by-id", data, headerConfig);
        return response;
};


const purchaseService = {
    purchaseSave,
    purchaseList,
    purchaseGetByID
};

export default purchaseService;